export enum OrderStatusLabel {
  SCHEDULED = "SCHEDULED",
  INPROGRESS = "IN PROGRESS",
  READY = "READY",
}
